import React from 'react';
import { Text, SimpleFlexbox } from 'ctm-components';
import styles from './no_results_overlay_generic.css';

/**
 * The results page content is different for whitelabel than CTM "no results".
 * Introduced a new component to avoid handling special requirments part of noResultsOverlay
 * @return {React} JSX
 */
const NoResultsOverlayGeneric = () => {
    return (
        <SimpleFlexbox className={styles.container} display="flex" column margin="top_xxlarge" xs={11}>
            <Text size="xxlarge" textAlign="center">
                Sorry, our providers were unable to provide you with a quote based on
                the information that you have entered.
            </Text>
            <Text textAlign="center">
                <p>This could be due to a variety of factors depending upon individual circumstances.</p>
                <p>
                    You may want to refer to the Insurance Council of Australia's "Find
                    an Insurer" website at
                    {' '}
                    <a href="https://www.findaninsurer.com.au//">www.findaninsurer.com.au</a>
                    {' '}
                    and
                    they may be able to provide you with a list of companies who can assist you with cover.
                </p>
            </Text>
        </SimpleFlexbox>
    );
};

export { NoResultsOverlayGeneric };
